import {Reference} from '../../core/definitions/reference';

export function cloneCompareValueReference(
  source: Reference | null | undefined,
  compareFieldReference?: Reference | null,
): Reference | null | undefined {
  if (!source) {
    return source;
  }
  const cloned = {...source};
  delete cloned.reference_id;
  cloned.hierarchic_select_descendants = !!compareFieldReference?.hierarchic_select_descendants;
  cloned.search_kulturnav = false;
  cloned.add_new_params = {...cloned.add_new_params, can_add_new: false};
  return cloned;
}
